const { LOCAL_CORE_VERSION } = require('../core');

/** @type {string} */
const SITEGEN_BUILD = process.env.SITEGEN_BUILD || LOCAL_CORE_VERSION;

module.exports.SITEGEN_BUILD = SITEGEN_BUILD;
